import {createRouter, createWebHistory} from "vue-router";
import AppLayout from "@/layout/AppLayout.vue";
import AppLayputBottom from "@/layout/AppLayputBottom.vue";
import dynamics from '@/router/subroute/dynamics'
import TextCheck from "@/components/general/TextCheck.vue";
import games from "@/router/subroute/games";
import PdfEdit from "@/components/general/PdfEdit.vue";
import FBARemobesAddress from "@/components/general/FBARemovesTheAddress.vue"

const routes = [
    {
        path: '/',
        name: 'Home',
        component: AppLayout,
        redirect:'/homepage',
        children: [
            ...dynamics
        ]
    },
    {
        path: '/notop',
        name: 'NoTop',
        component: AppLayputBottom,
        redirect:'/textcheck',
        children: [
            ...games,
            {
                path: '/textcheck',
                name: 'TextCheck',
                component: TextCheck
            },
            {
                path: '/pdfedit',
                name: 'PdfEdit',
                component: PdfEdit
            },
            {
                path: '/fbaremobesaddress',
                name: 'FBARemobesAddress',
                component: FBARemobesAddress
            }
        ]
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router
